<script setup lang="ts">
</script>

<template>
  <h2 class="font-medium mb-6 text-lg leading-6 pr-6">
    <slot></slot>
  </h2>
</template>
